/**
 * Fixed Title Case labels for Manual Assessment dynamic-form external footer actions.
 * @see docs/integrations/freyr-react-common/manual-assessment-external-buttons.md
 */
export const MANUAL_ASSESSMENT_ACTION_LABELS = {
  cancel: "Cancel",
  save: "Save",
  submit: "Submit",
} as const;

/** Ensures a button label starts with an uppercase letter (legacy footer overrides). */
export function formatActionButtonLabel(label: string, fallback: string): string {
  const trimmed = label.trim();
  const base = trimmed || fallback;
  if (!base) return base;
  return base.charAt(0).toUpperCase() + base.slice(1);
}
